import { parseClientEnv, siteUrl } from '@inboxkit/env/sites';

const env = parseClientEnv(import.meta.env);

export const API_URL = siteUrl('api', { env });
export const APP_URL = siteUrl('app', { env });
export const MARKETING_URL = siteUrl('marketing', { env });
